import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';
import { FONT_FAMILY_DEMI, FONT_FAMILY_REGULAR } from '../../../styles/fonts/MCFontConstants';

export const SurgeryNote = styled.div`
    width: 100%;
    height: 108px;
    text-align: center;
    font: 24px;
    color: #130e4a;
    font-family: ${FONT_FAMILY_DEMI};
    margin: 0 20px 0 0;

    ${media.mobileDevice`
        width: 100%;
        height: 31px;
        font-size: 18px;
        margin-top: ${({ isFromEquity, isCondensedView, isSurgery, bannerHeight }) =>
            (isSurgery && (!bannerHeight || bannerHeight === '0px')) ? '0px' : isFromEquity ? (isCondensedView ? '19px' : '30px') : '19px'};
        margin-bottom: -0.8px;
        margin-left: 25px;
        text-align: left;
    `}
`;

export const SurgeryClose = styled.div`
    margin: ${({ isFromEquity, isCondensedView, isSurgery, bannerHeight }) =>
        (isSurgery && (!bannerHeight || bannerHeight === '0px')) ? '0px 20px 10px 0px' :
        isFromEquity
            ? isCondensedView
                ? '24px 20px 10px 0px'
                : '35px 20px 10px 0px'
            : '24px 20px 21px 0px'};
`;
export const Subtitle = styled.div`
    font-family: ${({ fontFamily }) =>
    fontFamily ? fontFamily : FONT_FAMILY_DEMI};
    cursor: ${({ cursor }) => cursor && cursor};
    margin-left: ${({ marginLeft }) => marginLeft && marginLeft};
    align-items: center;
    display: flex;
    font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : 'unset')};
    color: ${({ fontColor }) => (fontColor ? fontColor : '#140f4b')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '16px')};
    border-bottom: ${({ borderBottom }) =>
        borderBottom ? borderBottom : 'none'};
    border-bottom-width: ${({ borderBottomWidth }) =>
        borderBottomWidth ? borderBottomWidth : 'none'};
    &:after {
        content: '${(props) => (props.showAstrisk ? '*' : '')}';
        color: red;
        padding-left: 3px;
    }

    ${media.smalDevice`
        font-size: ${({ fontSizeMobile }) =>
            fontSizeMobile ? fontSizeMobile : '15px'};
            line-height: ${({ lineHeightMob }) =>
                lineHeightMob ? lineHeightMob : '27px'};
    `}
`;
export const SurgeryInput = styled.textarea`
    width: 100%;
    height: 130px;
    background: #ffffff 0% 0% no-repeat padding-box;
    border: 1px solid #ebeded;
    border-radius: 6px;
    opacity: 1;
    margin-bottom: 10px;
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: 14px;
    padding: 9px 12px 0px 12px;
    resize: none;

    &:focus {
        outline: none;
    }

    &::-webkit-input-placeholder {
        color: #767676;
    }

    ${media.smalDevice`
        width: 100%;
    `}

    ${media.mobileDevice`
        width: 100%;
        height: 108px;
        // margin-right: 20px;
        // margin-left: 20px;
        margin-bottom: 20px;
        margin-top:10px;
    `}
`;

export const EditTextArea = styled.textarea`
    width: 90%;
    background: #ffffff 0% 0% no-repeat padding-box;
    border: none;
    border-radius: 6px;
    opacity: 1;
    margin-bottom: 10px;
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: 14px;
    padding: 9px 12px 0px 12px;
    resize: none;

    &:focus {
        outline: none;
    }

    &::-webkit-input-placeholder {
        color: #767676;
    }

    ${media.smalDevice`
        width: 100%;
    `}

    ${media.mobileDevice`
        width: 100%;
        height: 108px;
        // margin-right: 20px;
        // margin-left: 20px;
        // margin-bottom: 20px;
        // margin-top:-11px;
    `}
`;

export const Flex = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 12px 20px 0px 0px;
    border-left: ${({ showBorder }) =>
        showBorder ? '2px solid #12c8f7' : 'none'};
    padding-left: 15px;

    ${media.mobileDevice`
         margin: 10px 16px 0 16px;
    `}
`;

export const Hideflex = styled.div`
    display: none;
    ${media.mobileDevice`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: ${({ isFromEquity, isCondensedView, isSurgery, bannerHeight }) =>
            (isSurgery && (!bannerHeight || bannerHeight === '0px')) ? '60px' : isFromEquity ? (isCondensedView ? '19px' : '30px') : '19px'};
    `}
`;

export const ButtonDiv = styled.div`
    padding-top: 5px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: ${({ justifyContent }) =>
        justifyContent ? justifyContent : 'flex-start'};

    ${media.smalDevice`
        width: 100%;
        /* padding-left: 95px; */
    `}
    ${media.mobileDevice`
        width: 100%;
        padding-top: 0px;
        padding-left: 30px;
        padding-right: 30px;
        padding-bottom: 25px;
        justify-content: center;
    `}
`;

export const StyledDiv = styled.div`
    width: 100px;
    ${media.mobileDevice`
        width: 150px;        
        `}
`;

export const NoteDetails = styled.div`
    text-align: left;
    font-size: 14px;
    color: #202124;
    border-left: ${({ hideBorder }) =>
        hideBorder ? 'none' : '2px solid #12c8f7'};
    padding-left: 16px;
    font-family: ${FONT_FAMILY_REGULAR};
    word-break: break-word;
    opacity: 1;

    ${media.mobileDevice`
        padding-left: 0px;
    `}
`;

export const Creator = styled.p`
    text-align: left;
    font-size: 12px;
    color: #202124;
    font-family: ${FONT_FAMILY_DEMI};
    margin: 0 10px 0 0;
    overflow: hidden;
    opacity: 1;
    ${media.mediumDevice`
        width: 40%
    `}

    ${media.smalDevice`
        width: 30%;
    `}

    ${media.mobileDevice`
        width: 40%;
        margin: 0 5px 0 0;
    `}
`;

export const StyledDate = styled.div`
    text-align: left;
    font-size: 12px;
    color: #202124;
    opacity: 0.7;
    font-family: ${FONT_FAMILY_DEMI};
    margin: 0 10px;

    ${media.mobileDevice`
        margin: 0 5px;
    `}
`;

export const Bar = styled.div`
    width: 3px;
    height: 29px;
    text-align: left;
    color: #202114;
    opacity: 0.9;
`;

export const Time = styled.div`
    text-align: left;
    font-size: 12px;
    color: #202124;
    opacity: 0.7;
    font-family: ${FONT_FAMILY_DEMI};
    margin: 0 10px;

    ${media.mobileDevice`
        margin: 0 5px;
    `}
`;

export const Del = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1;
    cursor: pointer;
`;

export const Edit = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1;
    cursor: pointer;
`;

export const EditBox = styled.div`
    background-color: white;
    border: 1px solid #ebeded;
    padding: 10px;
    margin: 20px;
    display: flex;
    flex-direction: column;
    ${media.mobileDevice`
        margin: 0px;
    `}
`;
export const Roles = styled.div`
    width: 306px;
    height: 24px;
    text-align: left;
    font-size: 14px;
    letter-spacing: 0px;
    color: #202124;
    opacity: 1;
    font-family: ${FONT_FAMILY_REGULAR};

    margin-left: 25px;
    ${media.mobileDevice`
        margin-left: 25px;
    `}
`;

export const Line = styled.div`
    display: none;
    ${media.mobileDevice`
        width: 358px;
        height: 0px;
        border: 1px solid #70707080;
        opacity: 0.5;
        margin:auto;
        display:block;
    `}
`;
export const DesktopDivWithBorder = styled.div`
    margin-top: 0px;
    display: flex;
    flex-direction: column;
    width: 100%;
    border-right : 1px solid #dcdcdc;
padding-right: 20px;
    ${media.mobileDevice`
        margin-top : 0px;
        flex-wrap : wrap;
        justify-content: center;
    `}
`;
export const DesktopDiv = styled.div`
    margin-top: 0px;
    display: flex;
    flex-direction: column;
    width: 100%;

    ${media.mobileDevice`
        margin-top : 0px;
        flex-wrap : wrap;
        justify-content: center;
    `}
`;

export const Div = styled.div`
    width: 100%;
    // overflow:scroll;
    // height : calc(100vh - 150px);
`;

export const NoteDiv = styled.div`
    width: 100%;
    //height: calc(100vh - 216px);
    // overflow: scroll;
    background: #ffffff8a;
    ${scrollBarStyle}
    ${media.largeDevice` 
        // height: calc(100vh - 251px);
        // overflow:scroll;
    `}

    ${media.mediumDevice`
        // height: calc(100vh - 220px);
        // overflow:scroll;
         &::-webkit-scrollbar {
            display: none;
        }
    `}
    @media (max-width: 768px) and (orientation: portrait) {
        overflow:scroll;
    }
    ${media.mobileDevice`
        width: 100%;
        background:none;
        justify-content: center;
        height: calc(100vh - 510px);
        overflow:unset;
    `}
`;

export const Helper = styled.div`
    width: 300px;
    height: 24px;
    font-size: 14px;
    text-align: left;
    color: #767676;
    opacity: 1;
    margin-top: 4px;
    margin-left: 5px;
    font-family: ${FONT_FAMILY_REGULAR};
    ${media.mobileDevice`
        display:none;
`}
`;
export const Border = styled.div`
    width: 0.1vw;
    height: 715px;
    color: #707070;
   // opacity: 0.2;
    margin: ${({ margin }) => (margin ? margin : '0')};
    align-self: center;
    background-color: #dddddd;
    z-index: 999999999999;
    @media screen and (min-width: 768px) and (max-width: 1366px) and (orientation: portrait) {
       // height: 1030px;
       height: 100vh;
       background-color: #c3c3c3;
       border: 1px soild #c3c3c3;
        color: #707070;
        width: 1px;
       // z-index: 999999999999;
      //  position: relative;
    }

    
    @media screen and (min-width: 768px) and (max-width: 1366px) and (orientation: landscape) {
        height: 840px;
        color: #707070;
        width: 1px ;
      

        z-index: 999999999999;
    }

    ${media.mediumDevice`
      
    `}
    ${media.smalDevice`
      
    `}
    ${media.mobileDevice`
        display: none
    `}
`;

export const DisplayDiv = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 20px 20px 0 0;

    ${media.smalDevice`
        margin: 20px 0 0 0;
    `}

    ${media.mobileDevice`
        display: flex;
        flex-direction: column;
        width: 100%;
        margin: 0;
    `}
`;

export const SurgeryNoteCharactersCount = styled.p`
    font-size: 14px;
    color: #767676;
    margin: ${({ margin }) => (margin ? margin : '0')};
    gap: 30px;
    ${media.mobileDevice`
        margin:-15px 0 25px 0px;
    `}
`;
export const SubtitleDiv = styled.div`
    display: flex;
    justify-content: space-between;
    margin: ${({ margin }) => (margin ? margin : '0')};
`;
export const SurgeryExchangeDetails = styled.li`
    text-align: left;
    font-size: 14px;
    color: #202124;
    margin: 0 15px;
    font-family: ${FONT_FAMILY_REGULAR};
    word-break: break-all;
    opacity: 1;
    ${media.mobileDevice`
        margin: 0 16px;
        width: 90%;
    `}
`;

export const SuccessMsg = styled.div`
    font-size: 14px;
    font-family: ${FONT_FAMILY_REGULAR};
    letter-spacing: -0.11px;
    color: #14853d;
    float: ${(props) => props.float};
    ${media.mobileDevice` 
       margin: ${({ mbMargin }) => mbMargin && mbMargin};
    `};
    `;

export const MDICheckBoldImg = styled.img`
    float: left;
    margin-top: 3px;
    margin-right: 5px;
`;

export const DesktopContainer = styled.div`
    display: flex;
    gap: 30px;
`;

export const AccountContainer = styled.div`
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: ${({marginBottom}) => marginBottom ? marginBottom : ''}
`;

export const TickBlueImg = styled.img`
    cursor: pointer;
`;

export const CloseBlueImg = styled.img`
    cursor: pointer
`;

export const ImageContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 10px
`;

export const TextAreaContent = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
`;

export const RemainCharContent = styled.span`
    font-size: 12px;
`;

export const SaveButton = styled.button`
    margin-right: 10px;
`;

export const CancelButton = styled.button`
`;